import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|History|Program Fees|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

export type SPCandidateHistoryProgramFeesLocNames =
	| `SPCandidateHistoryProgramFeesTitlePage`
	| `SPCandidateHistoryProgramFeesTitleTab`
	| `SPCandidateHistoryProgramFeesLabelName`
	| `SPCandidateHistoryProgramFeesLabelId`
	| `SPCandidateHistoryProgramFeesLabelActiveDate`
	| `SPCandidateHistoryProgramFeesLabelExpireDate`
	| `SPCandidateHistoryProgramFeesLabelUpdated`
	| `SPCandidateHistoryProgramFeesLabelReviewStatus`
	| `SPCandidateHistoryProgramFeesLabelInvalid`
	| `SPCandidateHistoryProgramFeesLabelDataProvider`
	| `SPCandidateHistoryProgramFeesLabelDocumentation`
	| `SPCandidateHistoryProgramFeesLabelPoints`;

export const spCandidateProgramFeesLocs: LocDefs<SPCandidateHistoryProgramFeesLocNames> = {
	SPCandidateHistoryProgramFeesTitlePage: {
		defaultValue: 'Program Fees',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesTitleTab: {
		defaultValue: 'Program Fees',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelId: {
		defaultValue: 'ID',
		description: 'Column heading for: ID.',
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCandidateHistoryProgramFeesLabelPoints: {
		defaultValue: 'Points',
		description: 'Column heading for: Points.',
		displayPath: `${pathStart}Points`,
		displayType: 'Label',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'SP',
	},
};

export const spCandidateProgramFeesLocKeys = MapLocKeys<SPCandidateHistoryProgramFeesLocNames>(
	spCandidateProgramFeesLocs
);
export type SPCandidateHistoryProgramFeesLocType = typeof spCandidateProgramFeesLocKeys;
